import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  card: {
    width: "100%",
    maxWidth: 420,
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
      transform: "translateY(-4px)",
    },
  },
  imageContainer: (props) => ({
    width: "100%",
    height: 200,
    overflow: "hidden",
    borderRadius: "8px 8px 0 0",
    backgroundColor: props.imageBackground || "#07393d",
  }),
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    objectPosition: "center center",
  },
  content: {
    padding: 16,
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 8,
    color: "#333",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
  },
  description: {
    fontSize: 14,
    color: "#666",
    marginBottom: 16,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
    flex: 1,
  },
  options: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    marginTop: "auto",
  },
  optionButton: {
    alignItems: "center",
    backgroundColor: theme.palette.background.white,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 24,
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.12)",
    color: theme.palette.text.black,
    cursor: "pointer",
    display: "inline-flex",
    fontFamily: "inherit",
    fontSize: 14,
    justifyContent: "center",
    minHeight: 40,
    padding: "8px 14px",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "0 4px 10px rgba(0, 137, 123, 0.25)",
      color: theme.palette.primary.contrastText,
      transform: "translateY(-1px)",
    },
  },
  optionPrice: {
    fontWeight: 700,
  },
  optionPeriod: {
    fontWeight: 500,
  },
}));
